import { render, staticRenderFns } from "./_product.vue?vue&type=template&id=a2cd92c4&scoped=true&"
import script from "./_product.vue?vue&type=script&lang=js&"
export * from "./_product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2cd92c4",
  null
  
)

export default component.exports